import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';
import ResourceCenterSitemap from 'sly/sitemap/components/ResourceCenterSitemap';

export default ResourceCenterSitemap;

export const getServerSideProps = async () => {
  const { api, store } = createApiClient(apiEndpoints);

  const actions = [
    api.getTopic.asAction({
      populate: ['articles'],
    }),
  ];

  await Promise.all(actions.map(store.dispatch));

  return {
    props: {
      initialApiState: store.getState(),
    },
  };
};
